import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { StrapiPage } from '../gatsby/types/strapi-page';

export type AllPages = {
  allStrapiListingPageTranslation: {
    edges: {
      node: StrapiPage;
    }[]
  }
}

export const useStrapiListingPagesTranslations = (
): StrapiPage[] => {
  const { allStrapiListingPageTranslation } = useStaticQuery<AllPages>(graphql`
    query {
      allStrapiListingPageTranslation(filter: {
        pageSettings: {publishStatus: {eq: true}},
        seoSettings: {metaIndex: {eq: "index"}},
      }) {
        edges {
          node {
            id
            title
            pageSettings {
              id
              slug
              subpath
              language
              publishStatus
              parentPagePath
              parentPageTitle
            }
          }
        }
      }
    }
  `);

  return allStrapiListingPageTranslation.edges.map(({ node }) => node);
};

export default useStrapiListingPagesTranslations;
